module.exports = __webpack_public_path__ + "img/customer_design_2.769664b.jpg";